import React from "react";
import { Address } from "../../services/customer.address.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencilAlt,
  faPhone,
  faTrash,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../styles/app/AddressPage.module.css";

interface AddressCardProps {
  address: Address;
  currentUser?: any;
  onEdit?: (address: Address) => void;
  onDelete: (addressId: number) => void;
  onSetDefault?: (addressId: number) => void;
}

const AddressCard: React.FC<AddressCardProps> = ({
  address,
  currentUser,
  onEdit,
  onDelete,
  onSetDefault,
}) => {
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete(address.id);
  };

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onEdit) onEdit(address);
  };

  const handleSetDefaultClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onSetDefault && !address.isDefault) {
      onSetDefault(address.id);
    }
  };

  // Determine subject to display
  let subject: any = address.addressSubjet;

  // If no specific subject and it's an Origin address (US), fallback to current user
  if (!subject && address.isO2Country === "US" && currentUser) {
    subject = {
      firstName: currentUser.FirstName,
      lastName: currentUser.LastName,
      phoneNumber: currentUser.PhoneNumber,
      email: currentUser.Email,
      dni: currentUser.DNI,
      kindOfDNI: currentUser.KindOfDNI,
    };
  }

  return (
    <div className={`${styles.addressCardItem} ${address.isDefault ? styles.defaultCardItem : ""}`}>
      <div className={styles.cardContent}>
        <span className={styles.cardNickname}>
          {address.nickname}
          {address.isDefault && (
            <span className={styles.defaultBadge}>
              <FontAwesomeIcon icon={faStar} /> Predeterminada
            </span>
          )}
          {address.addressSubjet?.isThirdPerson && (
            <span className={styles.thirdPersonBadge}>Tercero</span>
          )}
        </span>

        {/* Subject Name */}
        {subject && (
          <div className={styles.subjectName}>
            {subject.firstName} {subject.lastName}
          </div>
        )}

        {/* Address Info */}
        <div className={styles.addressDetails}>
          <p className={styles.addressLine}>
            {address.addressLine1}, {address.city}, {address.state}{" "}
            {address.zipCode}
          </p>
        </div>

        {/* Phone Info */}
        {subject && (
          <div className={styles.subjectContact}>
            <FontAwesomeIcon
              icon={faPhone}
              style={{ fontSize: "12px", color: "#94a3b8" }}
            />{" "}
            {subject.phoneNumber}
          </div>
        )}
      </div>
      <div className={styles.cardActions}>
        {onSetDefault && (
          <button
            className={`${styles.actionBtn} ${address.isDefault ? styles.starBtnActive : styles.starBtn}`}
            onClick={handleSetDefaultClick}
            title={address.isDefault ? "Dirección predeterminada" : "Marcar como predeterminada"}
            disabled={address.isDefault}
          >
            <FontAwesomeIcon icon={faStar} />
          </button>
        )}
        {onEdit && (
          <button
            className={`${styles.actionBtn} ${styles.editBtn}`}
            onClick={handleEditClick}
            title="Editar"
          >
            <FontAwesomeIcon icon={faPencilAlt} />
          </button>
        )}
        <button
          className={`${styles.actionBtn} ${styles.deleteBtn}`}
          onClick={handleDeleteClick}
          title="Eliminar"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};

export default AddressCard;
